import { get, post, patch, getpagination, getAllResponse } from "../web.request";

export const getLocationList = async (data, id) => {
    return await getAllResponse(`/keywordplanner/location${data}`);
}

export const postKeywords = async (data, id, query) => {
    return await post(`/keywordplanner/keyword_planner_server/${id}${query}`, data);
}